export default __webpack_public_path__ + "media/components/Header/Images/Schema_black-4a155d772278bb8c8e0635a2ce5c86bb.svg";